import { Injectable } from '@angular/core';

export interface UserTypeBadge {
  label: string;
  /** Tailwind bg/text/border classes — pair with a static pill shape class in the template. */
  classes: string;
}

/**
 * Single source of truth for user-type colors (user_types_tb), so the same
 * type always renders with the same color everywhere (Users tab, access
 * profile users picker, etc.) instead of each screen picking its own.
 */
@Injectable({ providedIn: 'root' })
export class UserTypeBadgeService {
  private readonly byId: Record<number, UserTypeBadge> = {
    1: { label: 'Laboratório', classes: 'bg-slate-50 text-slate-500 border-slate-200' },   // neutral
    2: { label: 'Owner', classes: 'bg-yellow-50 text-yellow-700 border-yellow-200' },
    3: { label: 'Médico', classes: 'bg-sky-50 text-sky-600 border-sky-200' },   // sky blue — matches the app's primary color; not green (clashes with "active" status)
    4: { label: 'Paciente', classes: 'bg-purple-50 text-purple-600 border-purple-200' },
    5: { label: 'Usuário', classes: 'bg-orange-50 text-orange-600 border-orange-200' },
  };

  private readonly fallback = 'bg-slate-50 text-slate-500 border-slate-200';

  /** Looks up by user_type_id first; falls back to matching the name when the id isn't available. */
  getBadge(userTypeId?: number | null, userTypeName?: string | null): UserTypeBadge {
    if (userTypeId != null && this.byId[userTypeId]) {
      return this.byId[userTypeId];
    }
    const byName = userTypeName
      ? Object.values(this.byId).find((b) => b.label.toLowerCase() === userTypeName.toLowerCase())
      : undefined;
    return byName ?? { label: userTypeName || '', classes: this.fallback };
  }

  getClasses(userTypeId?: number | null, userTypeName?: string | null): string {
    return this.getBadge(userTypeId, userTypeName).classes;
  }
}
